var chunkToChildrenMap = {
	"init": [
		"default-src_components_views_elements_Dropdown_tsx-src_stores_OwnProfileStore_ts",
		"default-src_components_views_auth_PassphraseField_tsx",
		"styles",
		"default-vendors-node_modules_matrix-js-sdk_src_browser-index_ts-node_modules_matrix-org_react-68d116",
		"got-wicir"
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};